// src/api/projects.ts
import { apiRequest } from "./http";

export type ApiOk<T> = { ok: true; data: T };
export type ApiErr = { ok: false; error: string };

export type ApiProject = {
  id: string;
  tenant_id: string;

  client_id: string;
  name: string;
  address: string;

  status: string; // "Active" | "Settled" (or your values)
  archived: number; // 0/1 (recommended)
  created_at: string;
  updated_at: string;
};

// Your app's Project type (frontend)
export type UiProject = {
  id: string;
  clientId: string;
  name: string;
  address: string;
  totalEstimate: number; // derived elsewhere but exists in type
  status: string;
  archived?: boolean;
};

export function apiProjectToUi(p: ApiProject): UiProject {
  return {
    id: p.id,
    clientId: p.client_id,
    name: p.name,
    address: p.address,
    totalEstimate: 0, // derived via Scope later; safe default
    status: p.status || "Active",
    archived: Boolean(p.archived),
  };
}

export function uiProjectToApi(p: UiProject) {
  return {
    id: p.id,
    client_id: p.clientId,
    name: p.name,
    address: p.address,
    status: p.status || "Active",
    archived: p.archived ? 1 : 0,
  };
}

export async function listProjects(tenantId: string) {
  return apiRequest<ApiOk<ApiProject[]> | ApiErr>("GET", "/api/projects", { tenantId });
}

export async function createProject(tenantId: string, body: any) {
  return apiRequest<ApiOk<ApiProject> | ApiErr>("POST", "/api/projects", { tenantId, body });
}

export async function updateProjectById(tenantId: string, id: string, body: any) {
  return apiRequest<ApiOk<ApiProject> | ApiErr>("PATCH", `/api/projects/${id}`, { tenantId, body });
}

export async function deleteProjectById(tenantId: string, id: string) {
  return apiRequest<ApiOk<{}> | ApiErr>("DELETE", `/api/projects/${id}`, { tenantId });
}
